import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsDate, IsOptional } from 'class-validator';
import { JobCustomDateStartInterface } from '../interfaces/job-custom-date-start.interface';

export class JobCustomDateStartDto implements JobCustomDateStartInterface {
  @ApiProperty({
    type: 'string',
    format: 'date-time',
    nullable: true,
    title: 'Finish Date',
    description: 'Finish Date',
  })
  @Expose()
  @IsOptional()
  @IsDate()
  @Type(() => Date)
  customFinishDateStart!: Date;

  @ApiProperty({
    type: 'string',
    format: 'date-time',
    nullable: true,
    title: 'Custom Spray Date Start',
    description: 'Custom Spray Date Start',
  })
  @Expose()
  @IsOptional()
  @IsDate()
  @Type(() => Date)
  customSprayDateStart!: Date;

  @ApiProperty({
    type: 'string',
    format: 'date-time',
    nullable: true,
    title: 'Custom Prime Date Start',
    description: 'Prime Date Start',
  })
  @Expose()
  @IsOptional()
  @IsDate()
  @Type(() => Date)
  customPrimeDateStart!: Date;
}
